import { TreatmentCategoryDTO, TreatmentDTO } from '@auto-generated/ap-platform/care-providers';
import { isNullOrEmpty } from 'libs/shared/utils/src/lib/helpers';

export class TreatmentCategoryUtils {
	public static filterCategoryListByTreatmentList(treatmentCategoryList: TreatmentCategoryDTO[], treatmentList: TreatmentDTO[]): TreatmentCategoryDTO[] {
		if (!isNullOrEmpty(treatmentList)) {
			return treatmentCategoryList.filter(item => treatmentList.some(treat => treat.categoryId === item.id));
		}

		return [];
	}
}
